export const actSubjects = ["english", "math", "reading", "science"];
export const coreActSubjects = ["english", "math", "reading"];
export const actSubjectsWithCategories = ["english", "math"];
export const actSubjectsWithReview = [...actSubjects, "review"];
export const programDayTitles = [
  "Class Day",
  "Day 1",
  "Day 2",
  "Day 3",
  "Day 4",
  "Day 5",
  "Off Day",
];

export const studentAppSections = {
  dashboard: "Dashboard",
  "week-stats": "Week Stats",
  "week-report": "Week Reports",
  "good-news": "Good News",
  "pre-subject-reports": "Pre-Subject Reports",
  "take-a-test": "Take a Test",
  "take-a-challenge": "Take a Challenge",
  english: "English Instructions",
  math: "Math Instructions",
  awards: "Awards",
  settings: "Settings",
};

export const scheduleItemTypes = {
  BASIC: "basic",
  TEST: "test",
  CHALLENGE: "challenge",
  LESSON: "lesson",
  SECTION_LINK: "section-link",
  LINK: "link",
  MEMORIZATION: "memorization",
};

export const oddAnswerChoices = ["A", "B", "C", "D", "E"];
export const evenAnswerChoices = ["F", "G", "H", "J", "K"];
export const subjectQuestionCount = {
  classic: { english: 75, math: 60, reading: 40, science: 40 },
  2025: { english: 50, math: 45, reading: 36, science: 40 },
};
export const subjectTimeAllowed = {
  classic: { english: 45, math: 60, reading: 35, science: 40 },
  2025: { english: 35, math: 50, reading: 40, science: 40 },
};
